import { IInputProps } from 'modules';
import React, { FC } from 'react';

export const InputFileXlsx: FC<IInputProps> = ({
  onChange,
  onTouched,
  value,
  isReadOnly,
  onFocus,
}) => {
  return (
    <input
      type={'file'}
      id={'xlsxFileInput'}
      accept={'.xlsx'}
      onChange={(e) => onChange(e.target.files)}
    />
  );
};
